import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { RedirectTarget } from '@wix/cashier-core/dist/src/services/Payment/types';
import { ICashierSDKConfiguration } from '../cashier-sdk';
import { isInAppBrowser } from './isInAppBrowser';
import { isPayModalEnabled } from './isPayModalEnabled';

export const getRedirectTargetInfo = (
  sdkInitConfig: ICashierSDKConfiguration,
  params: {
    paymentMethod: PaymentMethod;
    frameable: boolean;
  }
): {
  redirectTarget?: RedirectTarget;
  forcedFullRedirectInIAB?: boolean;
} => {
  const { paymentMethod, frameable } = params;

  if (
    paymentMethod === PaymentMethod.Offline ||
    paymentMethod === PaymentMethod.InPerson
  ) {
    return {};
  }

  let redirectTarget: RedirectTarget;
  let forcedFullRedirectInIAB: boolean = false;

  if (
    frameable &&
    isPayModalEnabled(sdkInitConfig.appId) &&
    sdkInitConfig.openPayModal
  ) {
    redirectTarget = RedirectTarget.Embedded;
  } else if (sdkInitConfig.preferNewTabOverRedirect) {
    if (isInAppBrowser()) {
      redirectTarget = RedirectTarget.SameWindow;
      forcedFullRedirectInIAB = true;
    } else {
      redirectTarget = RedirectTarget.NewWindow;
    }
  } else {
    redirectTarget = RedirectTarget.SameWindow;
  }

  return {
    redirectTarget,
    forcedFullRedirectInIAB,
  };
};
